import { InjectionToken } from '@angular/core';
import { CommoSharedEnvironmentConfig } from './models';

export const COMMO_SHARED_ENVIRONMENT_CONFIG =
  new InjectionToken<CommoSharedEnvironmentConfig>(
    '@commo-client/commo/shared/environment Configuration',
  );
